var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverCardLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "60px",
    viewBox: "0 0 100 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Discover Card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 100,
    height: 60,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    d: "M24.115 60 L96 60 C98.209 60 100 58.213 100 56.005 L100 33.698 C100 33.698 73.199 51.868 24.115 60 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    href: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E7772F",
    href: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.29 29.822c-.75.642-1.706.923-3.235.923h-.634V23.085h.634c1.528 0 2.447.262 3.235.936.813.697 1.301 1.77 1.301 2.882 0 1.116-.488 2.229-1.301 2.919zm-2.761-8.7H12.058v11.585h3.448c1.835 0 3.159-.418 4.32-1.34 1.38-1.092 2.198-2.741 2.198-4.449 0-3.42-2.67-5.796-6.496-5.796z",
    fill: "#1A1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.114 21.122h2.353v11.585h-2.353z",
    fill: "#1A1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.244 25.563c-1.42-.498-1.835-.83-1.835-1.456 0-.728.742-1.28 1.762-1.28.707 0 1.29.271 1.91.933l1.228-1.542c-1.015-.855-2.23-1.288-3.554-1.288-2.142 0-3.775 1.426-3.775 3.312 0 1.601.759 2.414 2.974 3.185.926.308 1.397.519 1.636.661.472.292.707.71.707 1.194 0 .942-.78 1.635-1.835 1.635-1.123 0-2.032-.538-2.576-1.548l-1.522 1.41c1.088 1.526 2.393 2.208 4.19 2.208 2.451 0 4.178-1.57 4.178-3.806 0-1.843-.801-2.678-3.487-3.618",
    fill: "#1A1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.473 26.918c0 3.407 2.795 6.047 6.392 6.047 1.015 0 1.884-.192 2.955-.675v-2.662c-.946.91-1.777 1.269-2.851 1.269-2.377 0-4.06-1.646-4.06-3.994 0-2.219 1.738-3.977 3.957-3.977 1.12 0 1.976.379 2.955 1.303V21.57c-1.034-.5-1.883-.707-2.906-.707-3.577 0-6.442 2.692-6.442 6.055",
    fill: "#1A1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.949 28.9l-3.229-7.778h-2.574l5.132 11.878h1.266l5.232-11.878h-2.554z",
    fill: "#1A1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.847 32.708h6.695v-1.963h-4.333v-3.127h4.169v-1.963h-4.169v-2.57h4.333v-1.963h-6.695z",
    fill: "#1A1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.154 26.45h-.685v-3.504h.724c1.475 0 2.266.592 2.266 1.721 0 1.16-.79 1.783-2.305 1.783zm4.735-1.91c0-2.169-1.555-3.418-4.281-3.418h-3.507v11.585h2.367v-4.658h.307l3.262 4.658h2.905l-3.809-4.883c1.78-.348 2.756-1.511 2.756-3.284z",
    fill: "#1A1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.479 26.945c0 3.335-2.824 6.039-6.311 6.039-3.486 0-6.311-2.704-6.311-6.039s2.825-6.04 6.311-6.04c3.487 0 6.311 2.705 6.311 6.04",
    fill: "#E7772F"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverCardLight);
export default __webpack_public_path__ + "static/media/Discover-card-light.2d35e2e40f789fa1dda9f262b2c8cd52.svg";
export { ForwardRef as ReactComponent };